import React from 'react';
import { useDateFormat, useTimeFormat } from '../../../context/LocaleContext';
import s from './attendance.module.css';

// The lesson being marked, restated as three chips — the drawer's title is the
// student, so without this there is nothing saying which lesson this is.

export default function OccurrenceChips({ occurrence }) {
  const formatDate = useDateFormat();
  const formatTime = useTimeFormat();
  const chips = [
    // The studio's date and clock, not the stored strings — these chips sit
    // beside a delete dialog and a calendar that both format theirs.
    formatDate(occurrence.date),
    // An all-day lesson's stored time and length are inert (#160), and every
    // other surface says "All Day" in their place; so do these.
    occurrence.allDay ? 'All Day' : `${formatTime(occurrence.startTime)} · ${occurrence.durationMin} min`,
    occurrence.categoryLabel,
  ];

  return (
    <div className={s.chips}>
      {chips.map((text) => <span key={text} className={s.chip}>{text}</span>)}
    </div>
  );
}
